<template>
<!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
<span class="status-icon" :class="this.cssClass">
  <!-- <i class="nc-icon nc-check-2 text-success"         title="Complet"     v-if="status=='valid'"></i> -->
  <b-icon icon="check-all" variant="success" title="Complet" v-if="status=='valid'"/>
  <!-- <i class="nc-icon nc-watch-time text-warning"      title="En cours"    v-if="status=='doing'"></i> -->
  <b-icon icon="stopwatch" variant="warning" title="En cours" v-if="status=='doing'"/>
  <!-- <i class="nc-icon nc-settings-tool-66 text-danger" title="Brouillon"   v-if="status=='draft'"></i> -->
  <b-icon icon="pencil" variant="danger" title="Brouillon" v-if="status=='draft'"/>
  <!-- <i class="nc-icon nc-pin-3 text-info"              title="Réceptionné" v-if="status=='received'"></i> -->
  <b-icon icon="flag" variant="info" title="Soumis" v-if="status=='received'"/>
  <!-- <i class="nc-icon nc-square-pin text-primary"      title="Terminé"     v-if="status=='done'"></i> -->
  <b-icon icon="calendar-check" variant="primary"      title="Terminé"     v-if="status=='done'" />
</span>
</template>
<script>
  export default {
    name: 'status-icon', 
    props: {
      status: String, 
      cssClass: String
    },
    methods: {
      
    },
  }
</script>
<style>
</style>
